export function areRectsEqual(rectA: DOMRect | undefined, rectB: DOMRect | undefined) {
  if (!rectA || !rectB) return false

  return (
    rectA.x === rectB.x &&
    rectA.y === rectB.y &&
    rectA.width === rectB.width &&
    rectA.height === rectB.height &&
    rectA.top === rectB.top &&
    rectA.right === rectB.right &&
    rectA.bottom === rectB.bottom &&
    rectA.left === rectB.left
  )
}
